const messageTypes = {
	INFO: {
		type: 'INFO'
	},
	WARNING: {
		type: 'WARNING'
	},
	ERROR: {
		type: 'ERROR'
	},
	POSITIVE: {
		type: 'POSITIVE'
	},
	NEGATIVE: {
		type: 'NEGATIVE'
	},
	NEUTRAL: {
		type: 'NEUTRAL'
	}
}

export default messageTypes



// WEBPACK FOOTER //
// ./src/enums/messageTypes.js